// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_footer__HswBA { 
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.2);
}

.styles_footer__HswBA p {
  color: #898989;
  font-size: 12px;
  font-weight: 400;
}

.styles_footer__HswBA p a {
  color: #18316E;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/styles.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[".footer { \n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.2);\n}\n\n.footer p {\n  color: #898989;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.footer p a {\n  color: #18316E;\n  text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `styles_footer__HswBA`
};
export default ___CSS_LOADER_EXPORT___;
